
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ChecklistDialog extends Serenity.EntityDialog<ChecklistRow, any> {
        protected getFormKey() { return ChecklistForm.formKey; }
        protected getIdProperty() { return ChecklistRow.idProperty; }
        protected getLocalTextPrefix() { return ChecklistRow.localTextPrefix; }
        protected getNameProperty() { return ChecklistRow.nameProperty; }
        protected getService() { return ChecklistService.baseUrl; }
        protected getDeletePermission() { return ChecklistRow.deletePermission; }
        protected getInsertPermission() { return ChecklistRow.insertPermission; }
        protected getUpdatePermission() { return ChecklistRow.updatePermission; }

        protected form = new ChecklistForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            var buttonApply = Q.first(buttons, x => x.cssClass == "apply-changes-button");
            buttonApply.title = "Salva e continua";

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.NodiList.idChecklist = this.form.IdChecklist.value;

            if (this.isNew()) {
                if (this.idAssetEsperienza > 0) {
                    this.form.IdAssetEsperienza.value = this.idAssetEsperienza.toString();
                    Serenity.EditorUtils.setReadOnly(this.form.IdAssetEsperienza, true);
                }
            }

            // Enzo: commentata perchè il 20231006 hanno modificato i requisiti utenti.
            //this.form.RisorseList.ambito = RisorseChecklist2Editor.AmbitoEnum.VisualizzaRisorse;
            //this.form.RisorseList.idChecklist = this.form.IdChecklist.value;
        }

        loadEntity(entity: ChecklistRow) {
            super.loadEntity(entity);

            MyQ.hideEditorTab(this.form.NodiList, this.isNewOrDeleted());


            // Enzo: commentata perchè il 20231006 hanno modificato i requisiti utenti.
            //MyQ.hideEditorTab(this.form.RisorseList, this.isNewOrDeleted());           
        }

        ///////////////////////////////////
        private _idAssetEsperienza: number;

        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
            }
        }

    }
}